import { combineReducers } from '@reduxjs/toolkit';

import applicationDataReducer from './application-data';
import assetEditorReducer from './asset-editor';
import assetListingReducer from './asset-listing/asset-listing';
import channelEditorReducer from './channel-editor';
import clientSettingsReducer from './clientsettings';
import clipperReducer from './cliptool/clipper';
import FuelCalendarReducer from './fuel-calendar';
import fuelUserAccessReducer from './fuelUserAccess';
import ingestReducer from './ingest';
import liveProgramEditorReducer from './live-program-editor';
import ouAdminEditorReducer from './ou-admin-editor';
import SaveAssetJobsReducer from './saveAssetJobsState/SaveAssetJobsState';
import seriesListingReducer from './series-listing/asset-listing';
import userReducer from './user';
import ExportAnalyticsReducer from './exportAnalyticsState/ExportAnalyticsState';

const rootReducer = combineReducers({
  user: userReducer,
  applicationData: applicationDataReducer,
  fuelUserAccess: fuelUserAccessReducer,
  clientSettings: clientSettingsReducer,
  ouAdminEditor: ouAdminEditorReducer,
  assetEditor: assetEditorReducer,
  saveAssetJobs: SaveAssetJobsReducer,
  exportAnalyticsJobs: ExportAnalyticsReducer,
  ingest: ingestReducer,
  liveProgramEditor: liveProgramEditorReducer,
  channelEditor: channelEditorReducer,
  assetListing: assetListingReducer,
  seriesListing: seriesListingReducer,
  clipperState: clipperReducer,
  fuelCalendarState: FuelCalendarReducer,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
